import { createFileRoute } from '@tanstack/react-router';

import { CitationCreate } from '@/module/Author/Citation/CitationCreate';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { abstractId } = Route.useParams();

  return <CitationCreate publicationId={Number(abstractId)} />;
}
